import { t } from 'i18next';

/**
 *  Temporary fix before we unite integration and Skymap's errors into same common/error file.
 */
export type ErrorResponseErrorItemCodeLeica =
  | 'leica_auth:invalid_skymap_token'
  | 'leica_auth:unauthorized_skymap_token'
  | 'leica_auth:project_not_found'
  | 'leica_auth:unknown_error'
  | 'leica_auth:invalid_token'
  | 'leica_connection:not_found'
  | 'leica_connection:leica_project_already_connected'
  | 'leica_connection:leica_session_id_already_exists'
  | 'leica_connection:leica_project_token_already_exists';

export const translations = (): Record<ErrorResponseErrorItemCodeLeica, string> => {
  const unexpectedError = t('unexpectedError', {
    ns: 'common',
    defaultValue: 'Ett oväntat fel inträffade.',
  });
  return {
    'leica_auth:invalid_skymap_token': unexpectedError,
    'leica_auth:invalid_token': unexpectedError,
    'leica_auth:project_not_found': unexpectedError,
    'leica_auth:unauthorized_skymap_token': unexpectedError,
    'leica_auth:unknown_error': unexpectedError,
    'leica_connection:leica_project_already_connected': unexpectedError,
    'leica_connection:leica_project_token_already_exists': unexpectedError,
    'leica_connection:leica_session_id_already_exists': unexpectedError,
    'leica_connection:not_found': unexpectedError,
  };
};
